import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { CoSelfcheckAccountPage } from '../../pages/co-selfcheck-account/co-selfcheck-account';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoSelfcheckHeaderAccountButtonComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-selfcheck-header-account-button',
  templateUrl: 'co-selfcheck-header-account-button.html'
})
export class CoSelfcheckHeaderAccountButtonComponent {
  @Input() cssRules: any = {};
	@Input() standalone: boolean = false;
	@Output() logoutClicked = new EventEmitter<any>();
	@Output() myAccountClicked = new EventEmitter<any>();

  constructor(private state: AppState, private el:ElementRef) {
  }
  myaccount($event){
    if(this.standalone){
      this.state.nav.push(CoSelfcheckAccountPage);
    }else{
      this.myAccountClicked.emit($event);
    }
  }
  ngAfterViewInit(){
    if(this.cssRules){
      Object.keys(this.cssRules).forEach((key) => {
        let value = this.cssRules[key];
//        this.el.nativeElement.style[key]=value;
        this.el.nativeElement.style.setProperty(key, value, 'important');
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-selfcheck-header-account-button/co-selfcheck-header-account-button.ts